import { put, takeLatest } from 'redux-saga/effects';
import { setFilter } from '../reducers/filterSlice';

export function* workerFilterSaga({ payload }) {
    yield put(setFilter(payload))
}

export default function* filterSaga() {
    yield takeLatest("filters/getFilters", workerFilterSaga);
}